<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height= "70vh"  :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" show-select item-key="ID" v-model="selectedList">
                    <template v-slot:item="{ item, isSelected, select }">
                        <tr :id="'r-' + item.ID" :active="isSelected">
                            <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                            <td>{{ item.OrderTransactionCode }}</td>
                            <td class="text-right">
                                {{ item.Volume | currency('', 2) }} ({{ item.Length | currency }}x{{ item.Width | currency }}x{{ item.Height | currency }})                       
                            </td>
                            <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <v-flex lg12>
            <v-card>
                <h4 class="pa-4">Lịch sử nhận hàng không tên</h4>
                <hpo-filter :headers="noname_headers" :viewName="noname_viewName" v-on:applyFilter="noname_applyFilter" v-on:quickFilter="noname_quickFilter"></hpo-filter>
                <v-data-table fixed-header height= "70vh"  :headers="noname_headers" :items="noname_items" :options.sync="noname_pagination" :server-items-length="noname_total_rows" :footer-props="noname_items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.OrderTransactionCode }}</td>
                            <td>{{ item.Username }}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
         </v-flex>
    </v-layout>
    <v-dialog v-model="showDialogTrancode" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Mã vận đơn</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Mã vận đơn" v-model="newTransactionCode" @change="saveNewTrancode(false)"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="showDialogTrancode = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="saveNewTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { print_transaction } from "@/commons/hpod";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            selectedList: [],
            package_status: configs.PACKAGE_STATUS,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "transactioncode_list",
            filterConditions: [],
            quickFilterConditions: [],
            showDialogTrancode: false,
            newTransactionCode: '',
            noname_pagination: _.cloneDeep(configs.PAGINATION),
            noname_items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            noname_viewName: "noname_history_list",
            noname_filterConditions: [],
            noname_quickFilterConditions: [],
            noname_headers: [
                {
                    text: "Mã vận đơn",
                    value: "OrderTransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ngày nhận",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                }
            ]
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        noname_pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.noname_filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.noname_viewName] : []
                this.noname_filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.orderTransaction.all.data,
            total_rows: state => state.orderTransaction.all.total,
            noname_items: state => state.nonameHistory.all.data,
            noname_total_rows: state => state.nonameHistory.all.total,
            loading: state => state.orderTransaction.loading,
        }),
        headers() {
            let dataType = configs.DATA_TYPE;
            const isFilter = true;
            return [
                {
                    text: "Mã vận đơn",
                    value: "OrderTransactionCode",
                    filterable: isFilter,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end",
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    align: "end",
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: isFilter,
                    dataType: dataType["Enum"],
                    values: configs.PACKAGE_STATUS
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: isFilter,
                    dataType: dataType["Date"]
                }
            ];
        },
        adminRoles() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager); 
        },
        moduleRole() {
            return this.$store.state.authentication.role.Module;
        },
    },
    methods: {
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        printTransaction(weight, transactionCode, customerName, orderId, numberOfCode) {
            print_transaction(weight, transactionCode, customerName, orderId, numberOfCode);
        },
        saveItem:_.debounce(
        function(item) {
            var data = {
            ...item
            };
            data.Type = "transaction";
            data.ModifiedBy = this.$store.state.authentication.user.username;
            item.Status = data.Status = data.Weight > 0 ? configs.PACKAGE_STATUS_ENUM.DA_VE_VN : configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;
            delete data.CreatedDate;
            delete data.CreatedBy;
            this.$store.dispatch("orderTransaction/postOrderTransaction", data);
        }, 500, {leading: false, trailing: true}),
        refreshData() {
            this.filter_data();
            this.noname_filter_data();
        },
        // Only admin can view table, staff need search by code
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            param.filter.push({
                column: 'UID',
                value: 0,
                condition: "equal"
            });
            this.$store.dispatch("orderTransaction/getList", param);
        },
        noname_filter_data: function () {
            var param = {
                pagination: this.noname_pagination,
                filter: this.noname_filterConditions,
                quickFilter: this.noname_quickFilterConditions
            };
            this.$store.dispatch("nonameHistory/getList", param);
        },
        gotoDetail: function (type, id, uid) {
            if (type) {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    },
                    query: {
                        'uid': uid
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: "OrderDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = {...configs.PAGINATION};
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        noname_applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.noname_pagination = {...configs.PAGINATION};
            this.noname_pagination.sortBy = sortBy;
            this.noname_pagination.sortDesc = sortDesc;
            this.noname_filterConditions = filterConditions;
            this.noname_filter_data();
        },
        noname_quickFilter(filterConditions) {
            this.noname_quickFilterConditions = filterConditions;
            this.noname_filter_data();
        },
        dialogTrancode() {
            this.showDialogTrancode = true;
        },
        saveNewTrancode(isCloseDialog = true) {
            if(this.newTransactionCode.indexOf('http') > -1) {
                sendErrorNotice('Mã vận đơn không đúng định dạng.');
                return;
            }
            if(this.newTransactionCode != '') {
                this.$store.dispatch("orderTransaction/setDetail", {'data': {'OrderTransactionCode': this.newTransactionCode, 'Action': 'import_trancode'}});
                this.newTransactionCode = '';
            }
            this.showDialogTrancode = !isCloseDialog;
        },
        bulk_delete() {
            window.getApp.$emit('REQUEST_BULK_DELETE', this.selectedList.map((item) => {return item.ID;}), 'transaction_code');
        }
    },
    mounted() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("REQUEST_CREATE_DATA", this.dialogTrancode);
        this.$root.$on("PRE_BULK_DELETE", this.bulk_delete);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$off("REQUEST_CREATE_DATA", this.dialogTrancode);
        this.$root.$off("PRE_BULK_DELETE", this.bulk_delete);
    }
};
</script>
